__turbopack_context__.v({
  "grid": "M2GyKa_grid",
  "label": "M2GyKa_label",
});
